import React from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import { formatPhone } from '../../../utils/StringUtil'
import { CardTitle } from 'components/card/NewCard'
import { Card, CardContent, Grid, Stack } from '@mui/material'
import { Domain, MailOutline, Person, Phone, Print, Room, Smartphone } from '@mui/icons-material'


const IntervenantCard = ({ intervenant, title, actions = [], contributor }) => {
    const {
        cities,
        citiesHisto,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
        citiesHisto: store.CityReducer.citiesHisto,
    }), shallowEqual)

    const city = (intervenant.cityCodeDelegate ?
        citiesHisto.find((c) => c.cityCode === intervenant.cityCodeDelegate)
        :
        cities.find((c) => c.id === intervenant.cityCode)) || {}

    const address = (contributor ? intervenant.road : intervenant.address) || ''
    const addressComplement = (contributor ? intervenant.addressComplement : intervenant.additionalAddress) || ''
    const postalCode = (contributor ?
        (intervenant.postalCodeDelegate || intervenant.postalCode)
        :
        intervenant.postalBox) || ''
    return (
        <Card sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 2 }}>
            <CardTitle title={title} actions={actions} color='primary' />
            <CardContent>
                <Stack spacing={1}>
                    <Grid container spacing={1}>
                        {contributor ? <Domain /> : <Person />}
                        {intervenant.name || ''}
                    </Grid>
                    {address && (
                        <Grid container spacing={1}>
                            <Room />
                            {address}
                        </Grid>
                    )}
                    {addressComplement && (
                        <Grid container offset={0.6} spacing={1}>
                            {addressComplement}
                        </Grid>
                    )}
                    <Grid container offset={0.6} spacing={1}>
                        {(intervenant.cedex ? `${postalCode || ''} ${city.name || ''} ${intervenant.cedex || ''} [${city.code || ''}]` : `${postalCode || ''} ${city.labelWithCode || ''}`) || ''}
                    </Grid>
                    <Grid container spacing={1}>
                        <Phone />
                        {formatPhone(intervenant.phoneTel) || ''}
                    </Grid>
                    <Grid container spacing={1}>
                        <Smartphone />
                        {formatPhone(intervenant.mobile) || ''}
                    </Grid>
                    <Grid container spacing={1}>
                        <Print />
                        {formatPhone(contributor ? intervenant.fax : intervenant.desktopTel) || ''}
                    </Grid>
                    <Grid container spacing={1}>
                        <MailOutline />
                        {intervenant.email || ''}
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    )
}

IntervenantCard.propTypes = {
    title: PropTypes.string.isRequired,
    contributor: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        iconName: PropTypes.string,
    })),
    intervenant: PropTypes.oneOfType([
        PropTypes.instanceOf(ContributorDto),
        PropTypes.shape({}),
    ]).isRequired,
}

export default IntervenantCard